module.exports = __webpack_public_path__ + "static/img/about-img.1c717fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-img.png
// module id = aAhV
// module chunks = 0